import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-unauth-card',
    templateUrl: './unauth-card.component.html',
    styleUrls: ['./unauth-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UnauthCardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
